import { OnboardingSignupSuccess } from "../components/OnboardingSignupSuccess/OnboardingSignupSuccess";

export function OnboardingSignupSuccessPage() {
  return (
    <>
      <OnboardingSignupSuccess />
    </>
  );
}

export default OnboardingSignupSuccessPage;
